import "./styles.css"
import logo from './img/logo.png';
import animation from './img/desenho eu.png';


const Header = () => {
    return <header className="header">
        <div className="header-content">

            <div className="logo">
                <img src={logo} alt="Logo" />

            </div>
            <div className="nav">
                <a href="#home">Home</a>
                <a href="#about">Sobre mim</a>
                <a href="#projects">Projetos</a>
                <a href="#skills">Habilidades</a>
                <a href="#career">Carreira</a>
                <a href="#contact">Contato</a>
            </div>


        </div>

        <div className="header-main">

            <div className="header-name">
                <span className="badge">👋 Saudações!</span>
                <h1>Eu sou o Luis Henrique</h1>
                <h2>Desenvolvedor Full Stack</h2>
            </div>

            <div className="header-animation">
                <img src={animation} alt="Avatar ilustrado" />
            </div>

            <div className="header-cv">
                <button className="cv-button">Baixar CV</button>
            </div>

        </div>

        <hr />
    </header>
};

export default Header;